import React, { useState } from 'react';
import { EyeIcon, HideIcon } from './Icons';

const Input = ({
  id,
  type,
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  required,
  readOnly,
  errorText,
  onFocus,
  className = 'mb-md-10 mb-8',
  inputClassName,
}) => {
  const [showPass, setShopPass] = useState(false);

  return (
    <div className={`form-block ${className || ''}`}>
      {label && (
        <label htmlFor={id} className='fw-700 mb-5 mb-md-6'>
          {label} {required ? '*' : ''}
        </label>
      )}
      <input
        id={id}
        type={showPass ? 'text' : type}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
        onFocus={onFocus}
        className={`form-control is-${errorText ? 'invalid' : ''} ${inputClassName || ''}`}
      />
      {type === 'password' && (
        <button
          type='button'
          className='btn position-absolute r-0 t-0 mt-20 px-8'
          onClick={() => setShopPass(!showPass)}
        >
          {showPass ? <HideIcon /> : <EyeIcon />}
        </button>
      )}
      {errorText && <div className='invalid-feedback mt-5'>{errorText}</div>}
    </div>
  );
};

Input.defaultProps = {
  type: 'text',
  value: '',
  onChange: () => {},
};

export default Input;
